/**
 * Staff profiles, salary history and person bank details (BE-25) — real API.
 * Backend snake_case <-> camelCase here. A profile is EMPLOYEE or EXTERNAL; "Owner" is a choice in the Team dialog
 * (the partner link), never a stored type. Bank details belong to the person, not the profile.
 */

import ApiService from '../api.service';
import { keysCamelToSnake, unwrapData } from '../../utils/apiConvert';

export const EMPLOYMENT_TYPES = { EMPLOYEE: 'Employee', OWNER: 'Owner', EXTERNAL: 'External' };

export const staffService = {
  // [{ id, userId, fullName, loginEnabled, employmentType, joinDate, active, currentSalary? }]
  list: async () => unwrapData(await ApiService.get('/api/staff-profiles')),
  // body: { employmentType, joinDate, active } - only the fields sent change
  saveProfile: async (userId, body) => unwrapData(await ApiService.put(`/api/staff-profiles/by-user/${userId}`, keysCamelToSnake(body))),
  salaryHistory: async (profileId) => unwrapData(await ApiService.get(`/api/staff-profiles/${profileId}/salary-history`)),
  // body: { effectiveFrom, total, basic?, allowances? }
  setSalary: async (profileId, body) => unwrapData(await ApiService.post(`/api/staff-profiles/${profileId}/salary`, keysCamelToSnake(body))),
  // month: 'YYYY-MM' -> { userId, month, total, effectiveFrom } (total null when no salary stands)
  salaryFor: async (userId, month) => unwrapData(await ApiService.get('/api/staff-profiles/salary-for', { params: { user_id: userId, month } })),

  // { userId, accountHolderName, bankName, iban, accountNumber }; only userId when none is saved (finance read)
  getBank: async (userId) => unwrapData(await ApiService.get(`/api/person-bank-details/by-user/${userId}`)),
  // body: { accountHolderName, bankName, iban, accountNumber } - all empty removes the record (finance write)
  saveBank: async (userId, body) => unwrapData(await ApiService.put(`/api/person-bank-details/by-user/${userId}`, keysCamelToSnake(body))),
};
